import { Component, Optional, Inject, Input, ViewChild, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, Validators, FormGroup, FormBuilder, } from '@angular/forms';
import { ElementBase } from 'src/app/core/form/element-base';
import { debounceTime, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { StringUtilityServ } from 'src/app/core/services/utilities/string.service';

@Component({
  selector: 'app-inpt-airlines',
  templateUrl: './airlines.component.html',
  styleUrls: ['./airlines.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: InptAirlinesComponent, multi: true }
  ],
})
export class InptAirlinesComponent extends ElementBase<any> implements OnInit {
  @Input() public placeholder: string;
  @Input() public icon: boolean = true;
  @Input() public data: any;
  @ViewChild(NgModel) model: NgModel;
  public airportList: any;
  public form: FormGroup;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private fb: FormBuilder,
    private strServ: StringUtilityServ
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit() {
    this.airportList = this.data;
    // console.log('Aerolineas: ', this.data);
  }
  formatter = (x: { name: string, code: string }) => x && typeof x != "string" ? x.name + ' (' + x.code + ')' : x || '';
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => {
        if (term === '') {
          return [];
        }
        const filter = this.airportList.filter(f => {
          if (this.strServ.removeAccents(f.code).toLowerCase().indexOf(term.toLowerCase()) > -1) {
            return true;
          }
          if (this.strServ.removeAccents(f.name).toLowerCase().indexOf(term.toLowerCase()) > -1) {
            return true;
          }
          return false;
        });
        filter.sort((a, b) => {
          return a.priority - b.priority;
        });
        return filter.slice(0, 8);
      })
    )


}
